import React from "react";
import { Tooltip } from "@material-ui/core";
import GameActionButtons from "./GameActionButtons";

/**
 * RoundTracker
 * Displays round progression with pills and dividend indicators
 * Also includes GameActionButtons aligned to the right
 */
const RoundTracker = ({ 
  roundNumber, 
  maxRounds = 10,
  myTurn,
  onEndTurn,
  onEndGame,
  onStartTutorial,
  playerName,
  cash = 0,
  netWorth = 0,
  actionsRemaining = 0,
  maxActionsPerTurn = 3, // Can be 2 or 1 for first player when option on
}) => {
  // Generate array of round numbers from 1 to maxRounds
  const rounds = Array.from({ length: maxRounds }, (_, i) => i + 1);
  
  return (
    <div className="round-tracker" data-tutorial="round-tracker">
      {/* Logo - Top Left */}
      <div className="round-tracker-logo">
        <span className="game-logo-icon">📈</span>
        <h1 className="game-logo-text">Pump N Dump</h1>
      </div>
      
      <div className="round-tracker-content">
        {rounds.map((round) => (
        <React.Fragment key={round}>
          <Tooltip 
            title={
              roundNumber === round 
                ? `Round ${round} - Current Round` 
                : roundNumber > round 
                ? `Round ${round} - Completed` 
                : `Round ${round} - Upcoming`
            } 
            arrow 
            placement="top"
          >
            <div 
              className={`round-pill ${roundNumber === round ? 'active' : ''} ${roundNumber > round ? 'completed' : ''}`}
            >
              <span className="round-number">R{round}</span>
            </div>
          </Tooltip>
          {/* Show dividend pill after even rounds */}
          {round % 2 === 0 && (
            <Tooltip 
              title={
                roundNumber > round 
                  ? `Dividend paid after Round ${round}` 
                  : `Dividend will be paid after Round ${round}`
              } 
              arrow 
              placement="top"
            >
              <div className={`dividend-pill ${roundNumber > round ? 'paid' : ''}`}>
                <span className="round-pill-dividend-icon">🪙</span>
              </div>
            </Tooltip>
          )}
        </React.Fragment>
      ))}
      </div>
      
      {/* Game Action Buttons - Aligned Right */}
      <div className="round-tracker-actions">
        <GameActionButtons
          myTurn={myTurn}
          onEndTurn={onEndTurn}
          onEndGame={onEndGame}
          onStartTutorial={onStartTutorial}
          playerName={playerName}
          cash={cash}
          netWorth={netWorth}
          actionsRemaining={actionsRemaining}
          maxActionsPerTurn={maxActionsPerTurn}
        />
      </div>
    </div>
  );
};

export default RoundTracker;

